import React, { useEffect, useState, useRef } from "react";
import { Button, Modal, Table, ProgressBar } from "react-bootstrap";
import { Link } from "react-router-dom";

import api from "services/api";

import { __ } from "services/Translator";
import { Helmet } from "react-helmet";
import WheelOfFortune from "elements/WheelOfFortune";
import RankSlider from "elements/RankSlider";
import Slider from "react-slick";

export default function Rewards(props) {
  const DashboardCard = ({
    title,
    subtitle,
    points,
    progress,
    badge,
    icon,
    description,
    footer,
  }) => {
    return (
      <div className="dashboard-card">
        <div className="card-header">
          <div className="headingArea">
            {badge && <div className="badge greenAngleBtn">{badge}</div>}

            <p className="subtitle">{subtitle}</p>
            <h1 className="card-title">{title}</h1>

            {description && <p className="card-description">{description}</p>}
          </div>

          {icon && <>{icon}</>}
        </div>
        <div className="progress-section">
          <p className="progress-text">{points}</p>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>

        <div className="footer-text">
          <div className="left">Gold</div>
          <div className="right">Platinum</div>
        </div>
      </div>
    );
  };

  const TierCard = ({
    tier,
    icon,
    wheel,
    cashback,
    rakeback,
    vipManager,
    freeSpin,
    bonus,
  }) => {
    return (
      <div className="tier-card">
        <div className="tier-icon">
          <img src={require(icon).default} alt={`${tier} icon`} />
        </div>
        <h3 className="tier-name">{tier}</h3>
        <ul className="tier-details">
          <li>
            <strong>Wheel:</strong> {wheel}
          </li>
          <li>
            <strong>Cashback:</strong> {cashback}%
          </li>
          <li>
            <strong>Rakeback:</strong> {rakeback}%
          </li>
          <li>
            <strong>Personal VIP Manager:</strong> {vipManager}
          </li>
          <li>
            <strong>Free Spin:</strong> {freeSpin}
          </li>
          <li>
            <strong>Bonus:</strong> {bonus}
          </li>
        </ul>
      </div>
    );
  };

  const tiers = [
    {
      tier: "Bronze II",
      icon: "assets/images/rewards/rakeack.png",
      wheel: "Silver",
      cashback: 20,
      rakeback: 20,
      vipManager: "Yes",
      freeSpin: 500,
      bonus: 500,
    },
    {
      tier: "Silver III",
      icon: "assets/images/rewards/rakeack.png",
      wheel: "Silver",
      cashback: 20,
      rakeback: 20,
      vipManager: "Yes",
      freeSpin: 500,
      bonus: 500,
    },
    {
      tier: "Silver III",
      icon: "assets/images/rewards/rakeack.png",
      wheel: "Silver",
      cashback: 20,
      rakeback: 20,
      vipManager: "Yes",
      freeSpin: 500,
      bonus: 500,
    },
    {
      tier: "Silver III",
      icon: "assets/images/rewards/rakeack.png",
      wheel: "Silver",
      cashback: 20,
      rakeback: 20,
      vipManager: "Yes",
      freeSpin: 500,
      bonus: 500,
    },
    {
      tier: "Silver III",
      icon: "assets/images/rewards/rakeack.png",
      wheel: "Silver",
      cashback: 20,
      rakeback: 20,
      vipManager: "Yes",
      freeSpin: 500,
      bonus: 500,
    },
    // Add other tiers similarly
  ];

  //Wheel of fortune
  const [showWheel, setShowWheel] = useState(false);
  const [fortuneWheel, setFortuneWheel] = useState({});
  const [wheelWagerStatus, setWheelWagerStatus] = useState("");
  const openWheelPopup = () => {
    getWheelWagerStatus();
    setShowWheel(true);
  };
  const getWheelWagerStatus = async () => {
    var response = await api.get("/rewards/fortune-wheel/status");
    setFortuneWheel(response.data.wheel);
    setWheelWagerStatus(response.data.wagerStatus);
  };

  const [ranks, setRanks] = useState();
  const getRanks = async () => {
    // setSpinner(true);
    var response = await api.get("/player-levels");
    // setSpinner(false);
    if (response.status === 200) {
      setRanks(response.data);
    } else {
      props.showAlert("Warning!!", response.data.message);
    }
  };

  useEffect(() => {
    getRanks();
  }, []);

  //Rank slider
  const nextLoad = () => {
    ranksRef.current.slickNext();
  };

  const prevLoad = () => {
    ranksRef.current.slickPrev();
  };

  const ranksSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: false,
    customPaging: function (i) {
      return (
        <a className={props.landingType}>
          <div className="round">
            <i class="fas fa-circle"></i>
          </div>
          <div className="line"></div>
        </a>
      );
    },
    dotsClass: "slick-dots deposit_slider_dots",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const ranksRef = useRef();
  return (
    <>
      <Helmet>
        <title>
          {__(
            "Joker Casino | Race against other players for your chance to win a share of the prize pool!"
          )}
        </title>
        <meta
          name="description"
          content={__(
            "Joker Casino! View our current and upcoming tournaments where you take on other players - you all start with the same amount of chips, whoever ends with the most wins!"
          )}
        />
      </Helmet>

      <section className={"banner rewardBanner container-xxl "}>
        <div className="single_banner">
          <div className="banner_middle">
            {/* <div className="title italic">
                  {__("WELCOME TO JOKER CASINO")}
                </div> */}
            <div className="headline">
              {__("Rewards")} <br /> {__("Ranks Program")}
            </div>
            <div className="quotedHeadline">{__("No Any Slot Game.")}</div>
            <div className="paragraph small_screen_white padding_top_15 padding_bottom_15">
              {__(
                "Register and start playing right away with 20 Free Spins on a selection of awesome, thrilling games. You decide which game you want to play the free spins on."
              )}
            </div>

            <>
              <div className="banner_count padding_top_bottom_30">
                {props.totals && (
                  <>
                    <div className="count_area">
                      <div className="single_count">
                        <div className="number">
                          {props.totals.totalPlayers}+
                        </div>
                        <div className="paragraph">{__("Players Online")}</div>
                      </div>
                      <div className="single_count">
                        <div className="number">{props.totals.totalGames}+</div>
                        <div className="paragraph">{__("Games")}</div>
                      </div>
                    </div>
                  </>
                )}
                {props.isAuthenticated ? (
                  <Link
                    to="/games/slots"
                    className={"angle_btn " + props.landingType}
                  >
                    {__("Play Now")}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="red"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                      />
                    </svg>
                  </Link>
                ) : (
                  <Link
                    onClick={() => {
                      props.setModalSignUpPropsData(true);
                    }}
                    className={"angle_btn " + props.landingType}
                  >
                    {__("Sign Up Now")}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="red"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                      />
                    </svg>
                  </Link>
                )}
              </div>
            </>
          </div>
          <div className={"banner_img " + props.landingType}>
            {!props.isMobileDeviceByViewPort && (
              <img
                alt="game image"
                src={require("assets/images/banners/rewards-comp.png").default}
              />
            )}
            {props.isMobileDeviceByViewPort && (
              <img
                alt="game image"
                src={
                  require("assets/images/banners/rewards-comp-mobile.png")
                    .default
                }
              />
            )}
          </div>
        </div>
        {!props.isMobileDeviceByViewPort && (
          <div className="banner_features_list">
            <div className="single_item">{__("01. Best Quality")}</div>
            <div className="single_item">{__("02. Secure Payment")}</div>
            <div className="single_item">{__("03. Fast Pay - Outs")}</div>
            <div className="single_item">{__("04. Return Guarantee")}</div>
            <div className="single_item">{__("05. Support Customer")}</div>
          </div>
        )}
      </section>
      <div className="container-xxl">
        <div className="rewardContent">
          {!props.isMobileDevice && (
            <div className="dashboard-grid">
              <DashboardCard
                title="Eddy Mendez"
                subtitle="GET YOUR WELCOME PACKAGE"
                points="Additional Information / 223,456 pts"
                progress={60}
                badge="Gold I"
                icon={
                  <img
                    src={require("assets/images/rewards/medal.png").default}
                    alt="icon"
                  />
                } // Add icon image here
                footer="Gold I / Platinum IV"
              />
              <DashboardCard
                title="Wager Countdown"
                subtitle="GET YOUR WELCOME PACKAGE"
                points="Additional Information / 223,456 pts"
                progress={60}
                badge="Gold I"
                icon={
                  <img
                    src={require("assets/images/rewards/chips.png").default}
                    alt="icon"
                  />
                } // Add icon image here
                footer="Info Here"
              />
              <DashboardCard
                title="Rakeback"
                subtitle="GET YOUR WELCOME PACKAGE"
                description="As you play, we will give back some of your spending as rakeback."
                points="Additional Information / 223,456 pts"
                progress={70}
                footer="Gold I / Platinum IV"
                icon={
                  <img
                    src={require("assets/images/rewards/rakeack.png").default}
                    alt="rakeback icon"
                  />
                } // Add Rakeback icon image here
              />
              <DashboardCard
                title="Cashback"
                subtitle="GET YOUR WELCOME PACKAGE"
                description="If you are down and did not win, we are here for you to give back some of your losses."
                points="Additional Information / 223,456 pts"
                progress={50}
                footer="Gold I / Platinum IV"
                icon={
                  <img
                    src={
                      require("assets/images/rewards/golden-hand.png").default
                    }
                    alt="cashback icon"
                  />
                } // Add Cashback icon image here
              />
            </div>
          )}

          {props.isMobileDevice && (
            <>
              <div className="dashboard-grid">
                <Slider ref={ranksRef} {...ranksSettings}>
                  <DashboardCard
                    title="Eddy Mendez"
                    subtitle="GET YOUR WELCOME PACKAGE"
                    points="Additional Information / 223,456 pts"
                    progress={60}
                    badge="Gold I"
                    icon={
                      <img
                        src={require("assets/images/rewards/medal.png").default}
                        alt="icon"
                      />
                    } // Add icon image here
                    footer="Gold I / Platinum IV"
                  />
                  <DashboardCard
                    title="Wager Countdown"
                    subtitle="GET YOUR WELCOME PACKAGE"
                    points="Additional Information / 223,456 pts"
                    progress={60}
                    badge="Gold I"
                    icon={
                      <img
                        src={require("assets/images/rewards/chips.png").default}
                        alt="icon"
                      />
                    } // Add icon image here
                    footer="Info Here"
                  />
                  <DashboardCard
                    title="Rakeback"
                    subtitle="GET YOUR WELCOME PACKAGE"
                    description="As you play, we will give back some of your spending as rakeback."
                    points="Additional Information / 223,456 pts"
                    progress={70}
                    footer="Gold I / Platinum IV"
                    icon={
                      <img
                        src={
                          require("assets/images/rewards/rakeack.png").default
                        }
                        alt="rakeback icon"
                      />
                    } // Add Rakeback icon image here
                  />
                  <DashboardCard
                    title="Cashback"
                    subtitle="GET YOUR WELCOME PACKAGE"
                    description="If you are down and did not win, we are here for you to give back some of your losses."
                    points="Additional Information / 223,456 pts"
                    progress={50}
                    footer="Gold I / Platinum IV"
                    icon={
                      <img
                        src={
                          require("assets/images/rewards/golden-hand.png")
                            .default
                        }
                        alt="cashback icon"
                      />
                    } // Add Cashback icon image here
                  />
                </Slider>
              </div>
              <br />
              <div className="slider_prev_next ">
                <button onClick={prevLoad} className="action_btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="20"
                    fill="white"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                    />
                  </svg>
                  {__("Prev")}
                </button>
                <button onClick={nextLoad} className="action_btn">
                  {__("Next")}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="20"
                    fill="white"
                    class="bi bi-arrow-right"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                    />
                  </svg>
                </button>
              </div>
            </>
          )}

          <br />
          <section className="banner_bottom">
            <div className="banner_image">
              {!props.isMobileDeviceByViewPort && (
                <img
                  alt="game image"
                  style={{ width: "115%" }}
                  src={require("assets/images/rewards/spin-banner.png").default}
                />
              )}
              {props.isMobileDeviceByViewPort && (
                <img
                  alt="game image"
                  src={
                    require("assets/images/rewards/spin-banner-mobile.png")
                      .default
                  }
                />
              )}

              <div className="text_block">
                <div className="title italic">
                  {__("GET YOUR WELCOME PACKAGE")}
                </div>
                <div className="title heading padding_bottom_0">
                  {__("Spin the Wheel")}
                </div>
                <div className="title heading padding_top_0">
                  {__("Take your chances")}
                </div>

                {props.isAuthenticated ? (
                  <Link
                    to="/games/slots"
                    className={"angle_btn " + props.landingType}
                  >
                    {__("Spin Now!")}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="red"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                      />
                    </svg>
                  </Link>
                ) : (
                  <Link
                    onClick={() => {
                      props.setModalSignUpPropsData(true);
                    }}
                    className={"angle_btn " + props.landingType}
                  >
                    {__("Spin Now!")}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      fill="red"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                      />
                    </svg>
                  </Link>
                )}
              </div>
            </div>
          </section>
          <RankSlider {...props} />
        </div>
      </div>
      <Modal
        show={showWheel}
        dialogClassName="wheel_modal"
        onHide={() => setShowWheel(false)}
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <section className="lucky_wheel">
            <WheelOfFortune
              pendingWheelStatus={wheelWagerStatus}
              wheel={fortuneWheel}
              usePropsWheel={true}
              {...props}
            />
          </section>
        </Modal.Body>
      </Modal>
    </>
  );
}
